import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  CheckboxModule,
  InputModule,
  SelectDateYmdModule,
  SelectModule,
  TextTooltipModule,
  ValidationErrorModule,
} from '@lib/components';
import { AlertMessageModule } from '@lib/components/shared-ui-components/alert-area/alert-message/alert-message.module';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { AswMasterStoreModule } from '@lib/store';
import { TranslateModule } from '@ngx-translate/core';
import { SpecialAssistanceRequestModalComponent } from './special-assistance-request-modal.component';
import { SpecialAssistanceRequestModalFoldingTypeComponent } from './sub-components/special-assistance-request-modal-folding-type/special-assistance-request-modal-folding-type.component';
import { SpecialAssistanceRequestModalPregnantComponent } from './sub-components/special-assistance-request-modal-pregnant/special-assistance-request-modal-pregnant.component';
import { SpecialAssistanceRequestModalSpecialAssistanceComponent } from './sub-components/special-assistance-request-modal-special-assistance/special-assistance-request-modal-special-assistance.component';
import { SpecialAssistanceRequestModalWalkingAbilityComponent } from './sub-components/special-assistance-request-modal-walking-ability/special-assistance-request-modal-walking-ability.component';
import { SpecialAssistanceRequestModalWheelchairTypeComponent } from './sub-components/special-assistance-request-modal-wheelchair-type/special-assistance-request-modal-wheelchair-type.component';
import { SpecialAssistanceRequestModalWheelchairsComponent } from './sub-components/special-assistance-request-modal-wheelchairs/special-assistance-request-modal-wheelchairs.component';

@NgModule({
  declarations: [
    SpecialAssistanceRequestModalComponent,
    SpecialAssistanceRequestModalFoldingTypeComponent,
    SpecialAssistanceRequestModalSpecialAssistanceComponent,
    SpecialAssistanceRequestModalWalkingAbilityComponent,
    SpecialAssistanceRequestModalWheelchairTypeComponent,
    SpecialAssistanceRequestModalWheelchairsComponent,
    SpecialAssistanceRequestModalPregnantComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AmountFormatModule,
    StaticMsgModule,
    ButtonModule,
    InputModule,
    CheckboxModule,
    AswMasterStoreModule,
    ValidationErrorModule,
    SelectModule,
    SelectDateYmdModule,
    AlertMessageModule,
    TextTooltipModule,
  ],
  exports: [SpecialAssistanceRequestModalComponent],
})
export class SpecialAssistanceRequestModalModule {}
